'use client'

import { useViewBuilderPage } from '@src/utils/analytics.util'

interface AnalyticsProps {
  pageType?: string
  analyticsData?: Record<string, any>
}

export const Analytics = ({ pageType, analyticsData }: AnalyticsProps) => {
  useViewBuilderPage(pageType, analyticsData)

  return null
}
